<template>
  <va-create-layout>
    <series-form :title="title" :item="item"></series-form>
  </va-create-layout>
</template>

<script>
export default {
  props: {
    title: {
      type: String,
      default: '',
    },
    item: {
      type: Object,
      default: null,
    },
  },
};
</script>
